(function () {
  'use strict';

  /* ---------- icons ---------- */
  var I = {
    search: '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/>',
    flame: '<path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.07-2.14-.22-4.05 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.15.43-2.29 1-3a2.5 2.5 0 0 0 2.5 2.5Z"/>',
    ruler: '<path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"/><path d="m14.5 12.5 2-2"/><path d="m11.5 9.5 2-2"/><path d="m8.5 6.5 2-2"/><path d="m17.5 15.5 2-2"/>',
    clip: '<rect width="8" height="4" x="8" y="2" rx="1"/><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><path d="M12 11h4"/><path d="M12 16h4"/><path d="M8 11h.01"/><path d="M8 16h.01"/>',
    wrench: '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76Z"/>',
    puzzle: '<path d="M15.4 3.2a2.4 2.4 0 0 0-4.7 0c-.1.5-.5.8-1 .8H7.5A1.5 1.5 0 0 0 6 5.5v2.2c0 .5-.3.9-.8 1a2.4 2.4 0 0 0 0 4.7c.5.1.8.5.8 1V17a2 2 0 0 0 2 2h2.6c.5 0 .9.3 1 .8a2.4 2.4 0 0 0 4.7 0c.1-.5.5-.8 1-.8H20a2 2 0 0 0 2-2v-2.6c0-.5.3-.9.8-1a2.4 2.4 0 0 0 0-4.7c-.5-.1-.8-.5-.8-1V5.5A1.5 1.5 0 0 0 20.5 4h-2.1c-.5 0-1-.3-1-.8Z"/>',
    truck: '<path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/>',
    bag: '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/>',
    heart: '<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>',
    pencil: '<path d="M21.17 6.81a1 1 0 0 0-3.98-3.98L3.84 16.17a2 2 0 0 0-.5.83l-1.32 4.35a.5.5 0 0 0 .62.62l4.35-1.32a2 2 0 0 0 .83-.5Z"/><path d="m15 5 4 4"/>',
    tag: '<path d="M12.59 2.59A2 2 0 0 0 11.17 2H4a2 2 0 0 0-2 2v7.17a2 2 0 0 0 .59 1.41l8.7 8.7a2.43 2.43 0 0 0 3.42 0l6.58-6.58a2.43 2.43 0 0 0 0-3.42Z"/><circle cx="7.5" cy="7.5" r="1.1" fill="currentColor" stroke="none"/>',
    rotate: '<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/>',
    doc: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z"/><path d="M14 2v6h6"/><path d="M8 13h8M8 17h6"/>',
    arrowR: '<path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>',
    chev: '<path d="m9 18 6-6-6-6"/>',
    list: '<path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/>'
  };
  function svg(name) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' + (I[name] || I.doc) + '</svg>';
  }

  /* category name -> icon + blurb (matches the approved design) */
  var CATMETA = {
    'Choosing & Sizing': { icon: 'ruler', blurb: 'Pick the right length, weight and size for your body and style.' },
    'Product Specs': { icon: 'clip', blurb: 'Materials, wick sizes, burn times, battery life and dimensions.' },
    'How-To & Setup': { icon: 'wrench', blurb: 'Assembling, priming and getting your gear ready to play.' },
    'Compatibility & Parts': { icon: 'puzzle', blurb: 'Which parts, caps and modules fit together across our systems.' },
    'Shipping & Delivery': { icon: 'truck', blurb: 'Timeframes, tracking and shipping fire equipment safely.' },
    'Ordering & Availability': { icon: 'bag', blurb: 'Stock, pre-orders, back-in-stock alerts and order changes.' },
    'Care & Repair': { icon: 'heart', blurb: 'Looking after wicks, drums and bowls so they last for years.' },
    'Custom & Made-to-Order': { icon: 'pencil', blurb: 'Custom lengths, colours and one-off builds made just for you.' },
    'Pricing & Discounts': { icon: 'tag', blurb: 'Performer pricing, bundles and how our discounts work.' },
    'Returns & Refunds': { icon: 'rotate', blurb: 'What can be returned, and how refunds and exchanges work.' }
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function slug(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }

  /* ============================== HOME / CATEGORY APP ============================== */
  function initApp(root) {
    var view = root.querySelector('#view');
    var dataEl = document.getElementById('tw-help-data');
    if (!view || !dataEl) return;
    var ARTICLES;
    try { ARTICLES = (JSON.parse(dataEl.textContent).articles) || []; } catch (e) { return; }

    var cfg = {
      heading: root.getAttribute('data-heading') || 'How can we help?',
      sub: root.getAttribute('data-sub') || '',
      eyebrow: root.getAttribute('data-eyebrow') || 'Help Centre',
      popular: parseInt(root.getAttribute('data-popular'), 10) || 8,
      base: root.getAttribute('data-help-url') || ''
    };

    /* derive categories (ordered by count desc) */
    var counts = {};
    ARTICLES.forEach(function (a) { if (a.cat) counts[a.cat] = (counts[a.cat] || 0) + 1; });
    var CATS = Object.keys(counts).map(function (name) {
      var m = CATMETA[name] || {};
      return { id: slug(name), name: name, icon: m.icon || 'doc', blurb: m.blurb || '', count: counts[name] };
    }).sort(function (x, y) { return y.count - x.count; });
    var catById = {}; CATS.forEach(function (c) { catById[c.id] = c; });
    function artsOf(cid) { return ARTICLES.filter(function (a) { return slug(a.cat) === cid; }); }

    function pickPopular(n) {
      var out = [], used = {};
      CATS.forEach(function (c) {
        if (out.length >= n) return;
        var a = artsOf(c.id).filter(function (x) { return !used[x.id]; })[0];
        if (a) { out.push(a); used[a.id] = 1; }
      });
      ARTICLES.forEach(function (a) { if (out.length < n && !used[a.id]) { out.push(a); used[a.id] = 1; } });
      return out.slice(0, n);
    }

    function catCard(c) {
      return '<button class="cat-card" data-cat="' + c.id + '"><div class="ic">' + svg(c.icon) + '</div>' +
        '<div><h3>' + esc(c.name) + '</h3>' + (c.blurb ? '<p>' + esc(c.blurb) + '</p>' : '') +
        '<div class="n">' + c.count + ' ' + (c.count === 1 ? 'article' : 'articles') + '</div></div></button>';
    }
    function popRow(a) {
      return '<a class="pop-row" href="' + esc(a.url) + '"><div class="doc">' + svg('doc') + '</div>' +
        '<div class="t">' + esc(a.title) + '<span>' + esc(a.cat) + '</span></div>' +
        '<div class="arr">' + svg('arrowR') + '</div></a>';
    }

    function renderHome() {
      var popular = pickPopular(cfg.popular);
      view.innerHTML =
        '<section class="hero"><div class="wrap">' +
          '<div class="eyebrow">' + svg('flame') + ' ' + esc(cfg.eyebrow) + '</div>' +
          '<h1>' + esc(cfg.heading) + '</h1>' +
          (cfg.sub ? '<p class="sub">' + esc(cfg.sub) + '</p>' : '') +
          '<div class="bigsearch">' +
            '<span class="si">' + svg('search') + '</span>' +
            '<input type="search" data-search placeholder="Search help articles…" aria-label="Search help articles" autocomplete="off">' +
            '<div class="sd" data-results hidden></div>' +
          '</div>' +
          '<div class="popular">Popular: ' +
            ['fire staff length', 'djembe', 'shipping', 'returns'].map(function (q) {
              return '<a href="#" data-q="' + esc(q) + '">' + esc(q) + '</a>';
            }).join('·') +
          '</div>' +
        '</div></section>' +
        '<section class="block"><div class="wrap">' +
          '<div class="block-head"><h2>Browse by category</h2><span class="count">' + CATS.length + ' categories</span></div>' +
          '<div class="cat-grid">' + CATS.map(catCard).join('') + '</div>' +
        '</div></section>' +
        (popular.length ? '<section class="block"><div class="wrap">' +
          '<div class="block-head"><h2>Popular articles</h2><span class="count">Start here</span></div>' +
          '<div class="pop-grid">' + popular.map(popRow).join('') + '</div>' +
        '</div></section>' : '');
      wireSearch();
    }

    function renderCategory(cid) {
      var c = catById[cid];
      if (!c) { renderHome(); return; }
      var arts = artsOf(cid);
      var nav = CATS.map(function (x) {
        return '<button class="nl ' + (x.id === cid ? 'active' : '') + '" data-cat="' + x.id + '">' +
          svg(x.icon) + '<span>' + esc(x.name) + '</span><span class="n">' + x.count + '</span></button>';
      }).join('');
      var chips = CATS.map(function (x) {
        return '<button class="chip ' + (x.id === cid ? 'active' : '') + '" data-cat="' + x.id + '">' + esc(x.name) + '</button>';
      }).join('');
      view.innerHTML =
        '<div class="wrap">' +
          '<div class="crumb"><a href="#" data-home>Help Centre</a>' + svg('chev') + '<span class="cur">' + esc(c.name) + '</span></div>' +
          '<div class="cat-layout">' +
            '<aside class="cat-nav">' + nav + '</aside>' +
            '<div class="cat-main">' +
              '<h1><span class="ic">' + svg(c.icon) + '</span>' + esc(c.name) + '</h1>' +
              (c.blurb ? '<p class="lead">' + esc(c.blurb) + '</p>' : '') +
              '<div class="cat-chips">' + chips + '</div>' +
              '<div class="art-list">' + (arts.length ? arts.map(popRow).join('') : '<div class="empty"><h3>No articles yet</h3><p>Articles for this category are coming soon.</p></div>') + '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
    }

    /* live search dropdown */
    function wireSearch() {
      var input = view.querySelector('[data-search]');
      var box = view.querySelector('[data-results]');
      if (!input || !box) return;
      ARTICLES.forEach(function (a) {
        if (a._hay) return;
        a._title = (a.title || '').toLowerCase();
        a._hay = (a._title + ' ' + (a.cat || '') + ' ' + ((a.tags || []).join(' '))).toLowerCase();
      });
      function hide() { box.hidden = true; box.innerHTML = ''; }
      function hl(text, terms) {
        var out = esc(text);
        terms.forEach(function (t) { out = out.replace(new RegExp('(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>'); });
        return out;
      }
      function run() {
        var q = input.value.trim().toLowerCase();
        if (!q) { hide(); return; }
        var terms = q.split(/\s+/).filter(Boolean);
        var matches = ARTICLES.filter(function (a) {
          return terms.every(function (t) { return a._hay.indexOf(t) !== -1; });
        }).sort(function (x, y) {
          var sx = terms.filter(function (t) { return x._title.indexOf(t) !== -1; }).length;
          var sy = terms.filter(function (t) { return y._title.indexOf(t) !== -1; }).length;
          return sy - sx;
        }).slice(0, 8);
        if (!matches.length) {
          box.innerHTML = '<div class="sd-empty">No results for &ldquo;<b>' + esc(input.value.trim()) + '</b>&rdquo;. Try a different word.</div>';
        } else {
          box.innerHTML = matches.map(function (a) {
            return '<a class="res" href="' + esc(a.url) + '"><div class="rc">' + esc(a.cat) + '</div><div class="rt">' + hl(a.title, terms) + '</div></a>';
          }).join('');
        }
        box.hidden = false;
      }
      input.addEventListener('input', run);
      input.addEventListener('focus', function () { if (input.value.trim()) run(); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { hide(); input.blur(); } });
      document.addEventListener('click', function (e) {
        var bs = view.querySelector('.bigsearch');
        if (bs && !bs.contains(e.target)) hide();
      });
      view.querySelectorAll('[data-q]').forEach(function (q) {
        q.addEventListener('click', function (e) { e.preventDefault(); input.value = q.getAttribute('data-q'); input.focus(); run(); });
      });
    }

    /* router (home + category only; articles are real pages) */
    function route() {
      var h = location.hash || '';
      if (h.indexOf('#/c/') === 0) { renderCategory(h.slice(4)); window.scrollTo({ top: 0 }); }
      else { renderHome(); }
    }
    view.addEventListener('click', function (e) {
      var cat = e.target.closest('[data-cat]');
      if (cat) { e.preventDefault(); location.hash = '#/c/' + cat.getAttribute('data-cat'); return; }
      var home = e.target.closest('[data-home]');
      if (home) { e.preventDefault(); location.hash = ''; if (location.hash === '') route(); return; }
    });
    window.addEventListener('hashchange', route);
    route();
  }

  /* ============================== ARTICLE PAGE ============================== */
  function initArticle(root) {
    var body = root.querySelector('[data-article-body]');
    var wrap = root.querySelector('[data-art-wrap]');
    var tocAside = root.querySelector('[data-toc]');
    var tocList = root.querySelector('[data-toc-list]');
    var tocMobile = root.querySelector('[data-toc-mobile]');
    var tocListMobile = root.querySelector('[data-toc-list-mobile]');

    /* TOC from headings (assign ids if missing) */
    if (body && tocAside && tocList) {
      var hs = [].slice.call(body.querySelectorAll('h2, h3'));
      hs = hs.filter(function (h) { return h.textContent.trim().length; });
      if (hs.length >= 2) {
        hs.forEach(function (h, i) { if (!h.id) h.id = 'sec-' + (i + 1) + '-' + slug(h.textContent).slice(0, 24); });
        var links = hs.map(function (h) { return '<li><a href="#' + h.id + '" data-toc="' + h.id + '">' + esc(h.textContent) + '</a></li>'; }).join('');
        tocList.innerHTML = links;
        if (tocListMobile) tocListMobile.innerHTML = links;
        tocAside.hidden = false;
        if (tocMobile) tocMobile.hidden = false;
        if (wrap) wrap.classList.remove('no-toc');
        root.querySelectorAll('[data-toc]').forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            var el = document.getElementById(link.getAttribute('data-toc'));
            if (el) { var y = el.getBoundingClientRect().top + window.pageYOffset - 84; window.scrollTo({ top: y, behavior: 'smooth' }); }
            var det = link.closest('details'); if (det) det.open = false;
          });
        });
        var dLinks = [].slice.call(tocList.querySelectorAll('a'));
        if ('IntersectionObserver' in window) {
          var obs = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting) dLinks.forEach(function (l) { l.classList.toggle('active', l.getAttribute('data-toc') === en.target.id); });
            });
          }, { rootMargin: '-70px 0px -65% 0px', threshold: 0 });
          hs.forEach(function (h) { obs.observe(h); });
        }
      } else if (wrap) {
        wrap.classList.add('no-toc');
        if (tocAside) tocAside.remove();
        if (tocMobile) tocMobile.remove();
      }
    }

    /* feedback — visual ack + POST the vote (once per article per session) */
    var fb = root.querySelector('[data-feedback]');
    if (fb) {
      var btns = [].slice.call(fb.querySelectorAll('[data-fb]'));
      var thanks = fb.querySelector('.fb-thanks');
      var endpoint = fb.getAttribute('data-endpoint');
      var handle = fb.getAttribute('data-handle');
      var title = fb.getAttribute('data-title');
      var voteKey = handle ? 'twhc-fb-' + handle : null;
      var sent = false;
      try { if (voteKey && sessionStorage.getItem(voteKey)) sent = true; } catch (e) {}
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          if (thanks) thanks.classList.add('show');
          if (sent) return;
          sent = true;
          var vote = b.getAttribute('data-fb');
          try { if (voteKey) sessionStorage.setItem(voteKey, vote); } catch (e) {}
          if (endpoint && handle) {
            fetch(endpoint, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ handle: handle, title: title, vote: vote, url: location.href })
            }).catch(function () {});
          }
        });
      });
    }

    /* image lightbox */
    var gimgs = [].slice.call(root.querySelectorAll('.gimg[data-lightbox]'));
    if (gimgs.length) {
      var lb = document.createElement('div');
      lb.className = 'twhc-lb';
      lb.innerHTML = '<button type="button" class="twhc-lb-close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button><img alt="">';
      document.body.appendChild(lb);
      var lbImg = lb.querySelector('img');
      function closeLb() { lb.classList.remove('open'); document.body.style.overflow = ''; lbImg.removeAttribute('src'); }
      gimgs.forEach(function (g) {
        g.addEventListener('click', function () {
          lbImg.src = g.getAttribute('data-lightbox');
          lb.classList.add('open');
          document.body.style.overflow = 'hidden';
        });
      });
      lb.querySelector('.twhc-lb-close').addEventListener('click', closeLb);
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('open')) closeLb(); });
    }
  }

  function boot() {
    var app = document.querySelector('[data-help-app]');
    if (app) initApp(app);
    var art = document.querySelector('[data-help-article]');
    if (art) initArticle(art);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
